<template>
  <div >
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待认领" name="TaskClaim"
        ><!--v-if="qx2" -->
        <TaskClaim v-if="activeName == 'TaskClaim'"></TaskClaim>
      </el-tab-pane>
      <el-tab-pane label="转单中" name="TransferOrder">
        <TransferOrder v-if="activeName == 'TransferOrder'"></TransferOrder>
      </el-tab-pane>
      <el-tab-pane label="待接单" name="OrderTaking">
        <OrderTaking v-if="activeName == 'OrderTaking'"></OrderTaking>
      </el-tab-pane>
      <el-tab-pane label="执行中" name="Taskexecute"
        ><!--v-if="qx2" -->
        <Taskexecute v-if="activeName == 'Taskexecute'"></Taskexecute>
      </el-tab-pane>
      <el-tab-pane label="完结" name="TaskEnd">
        <TaskEnd v-if="activeName == 'TaskEnd'"></TaskEnd>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TaskClaim from "./components/TaskClaim.vue";
import Taskexecute from "./components/Taskexecute.vue";
import TaskEnd from "./components/TaskEnd.vue";
import TransferOrder from "./components/TransferOrder.vue";
import OrderTaking from "./components/OrderTaking.vue";
export default {
  components: {
    TaskClaim, // 正常写
    Taskexecute,
    TaskEnd,
    TransferOrder,
    OrderTaking
  },
  data() {
    return {
      activeName: "TaskClaim",
      qx: false, // 总经理、销售总监编辑的权限
      qx1: false, // 销售总监指派商机的权限
      qx2: false,
    };
  },
  created() {
    this.quanxian();
    if (this.$route.query.name) {
      this.activeName = this.$route.query.name
    }
  },
  methods: {
    handleClick(tab, event) {},
    //权限
    quanxian() {
      // 创建工单
      if (this.doesItContain()) {
        this.qx = true;
      }
      if (this.doesItContain([1, 32])) {
        // 部门主管接收工单
        this.qx1 = true;
        this.activeName = "TaskClaim";
      }
    },
  },
};
</script>

<style>
</style>